var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGmailIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-label": "Gmail",
  viewBox: "0 0 512 512"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 512,
  height: 512,
  fill: "#fff",
  rx: "15%"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4285f4",
  d: "M158 391V249l-82-63v175q0 30 30 30"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ea4335",
  d: "m154 248 102 77 102-77v-98l-102 77-102-77"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#34a853",
  d: "M354 391V249l82-63v175q0 30-30 30"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#c5221f",
  d: "m76 188 82 63v-98l-30-23c-27-21-52 0-52 26"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fbbc04",
  d: "m436 188-82 63v-98l30-23c27-21 52 0 52 26"
})));
export { SvgGmailIcon as ReactComponent };
export default __webpack_public_path__ + "81b05f7b01340d9e0d2b3261a03377f3.svg";